"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DadosVersao = void 0;
var DadosVersao = /** @class */ (function () {
    function DadosVersao(_a) {
        var _b = _a._id, _id = _b === void 0 ? { m: '', d: '', v: '', p: 0 } : _b, _c = _a.material, material = _c === void 0 ? '' : _c, _d = _a.data, data = _d === void 0 ? '' : _d, _e = _a.versao, versao = _e === void 0 ? '' : _e, _f = _a.prioridade, prioridade = _f === void 0 ? 0 : _f, _g = _a.chaveComp, chaveComp = _g === void 0 ? { material: '', data: '' } : _g, _h = _a.qtdTotal, qtdTotal = _h === void 0 ? 0 : _h;
        this._id = _id;
        this.material = material;
        this.data = data;
        this.versao = versao;
        this.prioridade = prioridade;
        this.chaveComp = chaveComp;
        this.qtdTotal = qtdTotal;
    }
    return DadosVersao;
}());
exports.DadosVersao = DadosVersao;
//# sourceMappingURL=DadosVersao.js.map